import { render } from "./UpcomingWorkingShiftView.vue?vue&type=template&id=1f566f6e"
import script from "./UpcomingWorkingShiftView.vue?vue&type=script&lang=js"
export * from "./UpcomingWorkingShiftView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__